export interface EnvConfig {
  prodHostnames?: string[];
  devHostnames?: string[];
}

export function matchesHost(hostname: string, targetHost: string): boolean {
  if (!hostname || !targetHost) return false;
  const cleanHost = targetHost.trim().toLowerCase();
  if (!cleanHost) return false;
  return hostname.trim().toLowerCase() === cleanHost;
}

export function getEnvLabel(
  hostname: string,
  config: EnvConfig
): "LOCAL" | "DEV" | null {
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "LOCAL";
  }

  const isProd = (config.prodHostnames || []).some((host) => matchesHost(hostname, host));
  if (isProd) {
    return null;
  }

  const isDev = (config.devHostnames || []).some((host) => matchesHost(hostname, host));
  if (isDev) {
    return "DEV";
  }

  // Fail-safe fallback: do not show a DEV badge in production for any unclassified domain
  return null;
}
